import { baseEnvironment, baseRecaptcha } from 'src/whiteLabel/mediaCorps/environments/environment.base';

export const environment = Object.assign({}, baseEnvironment, {
    production: true,
    disableUserCreation: true,
    prodUat: true,

    /**
     * api urls
     */
    apiUrl: 'https://ceapi.videologygroup.com',
    campaignUrl: 'https://ceapi.videologygroup.com',
    campaignDashboardUrl: 'https://dashboard-api.videologygroup.com',

    /**
    * values used for plan and campaign creation
    */
    platformClientId: 1248,

    /**
     * s3 info
     */
    s3BucketName: 'amobee-dspcreative-prod-ap',
    s3BucketRegion: 'ap-southeast-1',
    s3BucketFilePath: 'Prod/Creatives/BuyerCreative/',
    s3TemporaryCredentialsEndpoint: 'https://platform.amobee.com/aws/s3external/getCredentials',
});

/**
 * recaptcha info
 */
export const recaptcha = Object.assign({}, baseRecaptcha, {
    // Only available for tvbuying.amobee.com
    siteKey: '6LfodtkZAAAAAPkx-WNfgYwAqq9NNmWR8rxsxfNd',
    // v3 with programmatically invoke the challenge will require render for site key
    render: '6LfodtkZAAAAAPkx-WNfgYwAqq9NNmWR8rxsxfNd',
});
